/**
 * Translation hook for the journey logic (model, ports, graph operations). These modules are also loaded by the API
 * tests in Node, where lib/i18n cannot be imported (it touches `document` on load), so they go through this bridge.
 * The UI hands its `t` and locale over once (setJourneyI18n in JourneyCanvas / EditorCanvas / RunLogTimeline); until
 * then the Russian source text is shown, with the placeholders filled in.
 */
type Vars = Record<string, string | number>;

const fill = (text: string, vars?: Vars): string =>
  vars ? text.replace(/\{(\w+)\}/g, (m, k: string) => (vars[k] === undefined ? m : String(vars[k]))) : text;

let translate: (text: string, vars?: Vars) => string = fill;
let localeOf: () => string = () => 'ru-RU';

export function setJourneyI18n(i18n: { t: (text: string, vars?: Vars) => string; locale: () => string }): void {
  translate = i18n.t;
  localeOf = i18n.locale;
}

/** Translate a Russian source string (called at render or call time, never at module load). */
export function t(text: string, vars?: Vars): string {
  return translate(text, vars);
}

export function currentLocale(): string {
  return localeOf();
}
